<template>
	<q-card v-if="$q.platform.is.mobile" class="bg-grey-9 card-empty" dark>
		<q-card-section>
			<q-item-label>{{ $t(getText) }}</q-item-label>
		</q-card-section>
	</q-card>

	<q-card
		v-else
		class="full-height shadow-transition cursor-pointer card-empty"
		:class="class_hover"
		@mouseover="class_hover = 'shadow-5'"
		@mouseleave="class_hover = ''"
	>
		<q-card-section class="absolute-center full-width text-center">
			<p class="q-mt-sm text-body1">
				{{ $t(getText) }}
			</p>
		</q-card-section>
	</q-card>
</template>

<script>
export default {
	props: ['origin'],

	data() {
		return {
			class_hover: '',
		}
	},

	computed: {
		getText() {
			switch (this.origin) {
				case 'events':
					return 'no_events_available_for_the_selected_date'

				case 'news':
					return 'no_news_are_available_at_the_moment'

				case 'news_filtered':
					return 'no_news_are_available_with_the_selected_filter'

				case 'news_loading':
					return 'loading_news'

				case 'courses':
					return 'no_courses_are_available_at_the_moment'

				case 'courses_filtered':
					return 'no_courses_are_available_with_the_selected_filter'

				case 'courses_loading':
					return 'loading_courses'

				case 'trails':
					return 'no_trails_are_available_at_the_moment'

				case 'trails_filtered':
					return 'no_trails_are_available_with_the_selected_filter'

				case 'trails_loading':
					return 'loading_trails'

				case 'webinars_loading':
					return 'loading_webinars'

				case 'webinars_filtered':
					return 'no_webinars_are_available_with_the_selected_filter'

				case 'webinars':
					return 'no_webinars_are_available_at_the_moment'

				case 'live_classes_loading':
					return 'loading_live_classes'

				case 'live_classes_filtered':
					return 'no_live_classes_are_available_with_the_selected_filter'

				case 'live_classes':
					return 'no_live_classes_are_available_at_the_moment'

				case 'presentials_loading':
					return 'loading_presential_classes'

				case 'presentials_filtered':
					return 'no_presential_classes_are_available_with_the_selected_filter'

				case 'presentials':
					return 'no_presential_classes_are_available_at_the_moment'

				case 'libraries_loading':
					return 'loading_files'

				case 'libraries_filtered':
					return 'no_files_are_available_with_the_selected_filter'

				case 'libraries':
					return 'no_files_are_available_at_the_moment'

				case 'podcasts_loading':
					return 'loading_podcasts'

				case 'podcasts_filtered':
					return 'no_podcasts_are_available_with_the_selected_filter'

				case 'podcasts':
					return 'no_podcasts_are_available_at_the_moment'

				default:
					return ''
			}
		},
	},
}
</script>

<style></style>
